import React from "react";
import Layout from "../../reusables/layout/layout";
import RegisterTradeTest from "../../Component/registerform/registerTradeTest";

const PaymentRegisterTradeTest = () => {
  return (
    <div>
      <Layout>
        <RegisterTradeTest
          examType={"TRADE TEST REGISTRATION"}
          serviceType={"trade test service"}
          navigateTo={"/tradetest/payment/login"}
        />
      </Layout>
    </div>
  );
};

export default PaymentRegisterTradeTest;
